module.exports = __webpack_public_path__ + "assets/46bb699ddf47561797206f69303a4655.mp3";